/**
 * if something should happen a little delayed
 * but jqueries delay isn't usable use this one
 *
 * Examples:
 *   oyc.Delay.init('just-a-name', 300, myFunction);  // without brackets
 *   oyc.Delay.init('just-a-name', 300, function(){
 *     // commands to execute
 *   });
 */
oyc.Delay = {
  noAutoLoad: true,
  timers: {},
  knocked: {},
  /**
   *
   * @param {function} callback a simple identifier for the delay (to be able to delay things paral
   * @param {integer} ms the period to delay the function call
   * @param {string} uniqueId pointer to a function or an anonymous function to be called delayed
   * @param {object} uniqueId pointer to a function or an anonymous function to be called delayed
   * @param {mixed} uniqueId pointer to a function or an anonymous function to be called delayed
   * @returns {undefined}
   */
  init: function (callback, ms, uniqueId, bind, arg, immediateCall) {
    immediateCall = immediateCall || false;
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (immediateCall) {
      if (this.timers[uniqueId]) {
        this.knocked[uniqueId] = {
          callback: callback,
          bind: bind,
          arg: arg
        };
        return;
      }

      if (bind === undefined) {
        callback(arg);
      } else {
        callback.bind(bind, arg)();
      }
      this.timers[uniqueId] = setTimeout(this.removeTimerId.bind(this, uniqueId), ms);
    } else {
      if (this.timers[uniqueId]) {
        clearTimeout(this.timers[uniqueId]);
      }
      if (bind === undefined) {
        this.timers[uniqueId] = setTimeout(callback, ms);
      } else {
        this.timers[uniqueId] = setTimeout(callback.bind(bind, arg), ms);
      }
    }
  },
  removeTimerId: function (uniqueId) {
    if (uniqueId in this.timers) {
      this.timers[uniqueId] = false;
    }
    if (uniqueId in this.knocked) {
      if (typeof this.knocked[uniqueId].bind !== 'undefined') {
        this.knocked[uniqueId].callback.bind(this.knocked[uniqueId].bind, this.knocked[uniqueId].arg);
      } else {
        this.knocked[uniqueId].callback(this.knocked[uniqueId].arg);
      }
    }
  },
  abort: function (uniqueId) {
    console.debug('abort request "' + uniqueId + '" from timer');
    clearTimeout(uniqueId);
    this.removeTimerId(uniqueId);
  }
};
